// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"HomeFeatured_Wrapper__3zJLh","Banner":"HomeFeatured_Banner__pFRZ5"};